exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".CTAs-9b7354a9{width:100%;height:40px;margin-right:auto;margin-top:10px;display:flex;justify-content:flex-start}.followCTA-ae75236f{flex:0 1 33%}\n", ""]);

// Exports
exports.locals = {
	"CTAs": "CTAs-9b7354a9",
	"followCTA": "followCTA-ae75236f"
};